<template>
  <router-view v-slot="{ Component }">
    <component :is="Component" />
  </router-view>

  <sbs-message />
  <sbs-network-error />
</template>

<script>
import bus from "@/plugins/bus";
import ws from "@/plugins/websocket"

import { mapGetters } from "vuex";

import sbsMessage from "@/components/message";
import sbsNetworkError from "@/components/network-error";

export default {
  name: "App",
  components: {
    sbsMessage,
    sbsNetworkError,
  },
  computed: {
    ...mapGetters({
      theme: "getTheme",
    }),
  },
  watch: {
    theme: function () {
      this.applyTheme();
    },
  },
  methods: {
    /**
     * Применение темы
     */
    applyTheme: function () {
      let root = document.documentElement;

      root.classList.remove("theme-" + root.dataset.theme);
      root.classList.add("theme-" + this.theme);
      root.dataset.theme = this.theme;
    },

    /**
     * Обработка входа пользователя
     */
    async onLogin() {
      //регистрируем подключение по вебсокету
      ws.register();

      //загрузим настройки клиента
      try {
        await this.$store.dispatch("loadClientSettings");
      } catch (e) {
        //здесь уже подразумевается, что приложение загружено
        //может пользователь добавляет новый аккаунт
        //а может разлогинился и пытается снова зайти
        //так вот в этом случае все ошибки через bus будут показываться 
        //стандартным нашим уведолмением
        //а вот в main.js уведомления недоступны
        //поэтому пришлось в loadClientSettings сделать Reject и в местах использования try/catch
      }

      //загрузим профиль пользователя
      this.$store.dispatch("loadUserData");

      //переход на главный экран
      this.$router.replace({ name: "home" });
    },

    /**
     * Выход пользователя
     */
    logout() {

      //специально убрал весь код по сбросу авторизации в store
      //так как при старте страницы ещё до создания/монтирования App
      //выполняется запрос на получение настроек и если в ответе
      //будет "срок действия токена истёк", то нужно как-то сбросить авторизацию
      //без App

      //переход на страницу входа
      this.$router.push({ name: "login" });

    },
  },

  created() {

  },

  mounted() {
    this.applyTheme();

    //подписваемся на событие авторизации пользователя
    bus.on("SBS_APP_E_USER_LOGIN", this.onLogin);
    //подписваемся на событие выхода
    bus.on("SBS_APP_E_LOGOUT", this.logout);
  },
  unmounted() {
    //отписываемся от событий
    bus.off("SBS_APP_E_USER_LOGIN", this.onLogin);
    bus.off("SBS_APP_E_LOGOUT", this.logout);
  },
};
</script>

<style lang="scss">
#app {
  overflow: auto;
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
}
</style>
